import type { LatLng, Place, SearchAddressResult } from '../@types';
import type { SatellitePlace } from '../context/types';

// Satellite Location in Gozio client's network
export function isSatellitePlace(object: any): object is SatellitePlace {
  return object && typeof object === 'object' && 'destination_geo' in object;
}

export function isSearchAddressResult(
  object: any,
): object is SearchAddressResult {
  return (
    object &&
    typeof object === 'object' &&
    'address' in object &&
    'geolocation' in object &&
    'lat' in object.geolocation &&
    'lon' in object.geolocation &&
    'position' in object &&
    Array.isArray(object.position) &&
    object.position.length === 2
  );
}

// Internally Defined Place
export function isGozioPlace(object: any): object is Place {
  return (
    object &&
    typeof object === 'object' &&
    'location_type' in object &&
    'name' in object &&
    !('formatted_address' in object)
  );
}

// LatLng
export function isLatLng(object: any): object is LatLng {
  return (
    object && typeof object === 'object' && 'lat' in object && 'lng' in object
  );
}

export function isPotentialGooglePlaceId(str: string) {
  return str.length > 10;
}

export function isLatLongString(str: string | null) {
  return str?.includes(',');
}
